import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import DefaultView from 'components/ui/DefaultView';
import { adminRoutes } from 'routes';
import Home from './Home';
import { getUser } from 'services/token';
import AppRoute from 'components/AppRoute';

const RedirectTo404Page = () => <Redirect to="/404" />;

const Admin = () => {
  let currentUser = JSON.parse(getUser());

  if (currentUser.role === 'regular') return <Redirect to="/" />;

  return (
    <DefaultView>
      <Switch>
        <Route component={Home} exact path="/admin" />
        {adminRoutes.map(({ component, path, permission }) => (
          <AppRoute
            component={component}
            key={path}
            path={path}
            permission={permission}
          />
        ))}
        <Route component={RedirectTo404Page} />
      </Switch>
    </DefaultView>
  );
};

export default Admin;
